<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <FontawesomeIcon v-if="!group1.isListFormDownloadsLoaded" 
            :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" />
          <template v-else>
            <p v-if="group1.message !== ''" class="popup-title-text" v-html="group1.messageDisp"></p>
          </template>
        </div>
        <div class="popup-content">

          <FontawesomeIcon v-if="!group1.isListFormDownloadsLoaded" 
            :icon="['fal','spinner-third']" size="2x" class="icn fa-spin center" />
          <template v-else>
            <p v-for="(item, index) in group1.list" :key="'document_downloads_' + index" class="link">
              <a :href="item.url" class="txt-blue ga-qa-popup-shoshiki-download">
                <FontawesomeIcon icon="arrow-to-bottom" class="icn ga-qa-popup-shoshiki-download" />
                {{ item.format_name }}
              </a>
            </p>
          </template>

        </div>
      </div>
    </div>
    <iframe style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%; z-index: -1;" src="about:blank"></iframe>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import * as logicQADocumentDownloads from '@/logic/qa/QADocumentDownloads'

export default defineComponent({
  props: {
    startLoading: {
      type: Boolean,
      required: true
    }
  },
  setup (props, context) {

    const group1 = logicQADocumentDownloads.getGroup(props, context)

    const close = () => {
      context.emit('closeDocumentDownloads')
    }
    const submit = () => {
      context.emit('closeDocumentDownloads')
      // todo submitの処理
    }
   
    return {
      group1,
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-title-text {
  font-size: 1.8rem;
  line-height: 2;
}
.popup-content {
  min-height: 560px;
  .link {
    font-size: 1.8rem;
    @include hoverOpacity();
    & + .link {
      margin-top: 12px;
    }
    .icn {
      margin-right: 5px;
    }
  }
}
</style>
